import { XCircle } from 'lucide-react';
import { APPOINTMENT_STATUS } from 'utils/constants';

interface StatusBadgeProps {
  status: string;
  /**
   *  - "soft": neutral grey, capitalize. Cancelled is highlighted red with an icon.
   *  - "pill": uppercase tracking-wider, color-mapped per status (blue/red/green/grey).
   */
  variant?: 'soft' | 'pill';
}

const SOFT_BASE =
  'inline-flex items-center gap-1 text-[11px] font-semibold px-2.5 py-1 rounded-md uppercase';
const PILL_BASE =
  'inline-flex items-center text-[11px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full';

const PILL_COLORS: Record<string, { bg: string; text: string }> = {
  [APPOINTMENT_STATUS.SCHEDULED]: { bg: 'bg-blue-50', text: 'text-blue-700' },
  [APPOINTMENT_STATUS.CANCELLED]: { bg: 'bg-red-50', text: 'text-red-700' },
  [APPOINTMENT_STATUS.COMPLETED]: { bg: 'bg-green-50', text: 'text-green-700' },
  [APPOINTMENT_STATUS.UNSCHEDULED]: { bg: 'bg-gray-100', text: 'text-gray-700' },
};
const PILL_FALLBACK = { bg: 'bg-gray-100', text: 'text-gray-700' };

export const StatusBadge = ({ status, variant = 'soft' }: StatusBadgeProps) => {
  const cfg = PILL_COLORS[status?.toLowerCase()] ?? PILL_FALLBACK;

  if (variant === 'pill') {
    return (
      <span className={`${PILL_BASE} ${cfg.bg} ${cfg.text}`}>{status}</span>
    );
  }
  if (status === APPOINTMENT_STATUS.CANCELLED) {
    return (
      <span className={`${SOFT_BASE} bg-red-50 text-red-600`}>
        <XCircle size={12} />
        {status}
      </span>
    );
  }
  return <span className={`${SOFT_BASE} ${cfg.bg} ${cfg.text}`}>{status}</span>;
};
